import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const MainWrapper = styled.div`
	background-color: ${colors.grey1};
	height: 100%;
	display: flex;

	&::-webkit-scrollbar {
		width: 5px;
	}

	&::-webkit-scrollbar-thumb:vertical {
		background-color: #888;
		border-radius: 7px;
	}

	&::-webkit-scrollbar-track:vertical {
		background-color: #f1f1f1;
		border-radius: 5px;
	}

	/* For Firefox */
	scrollbar-width: thin;
	scrollbar-color: #888 #f1f1f1;

	/* Additional styling for the track in Firefox */
	& {
		scrollbar-track-color: #f1f1f1;
	}
`;
export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 100%;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 5px;
	}

	&::-webkit-scrollbar-thumb:vertical {
		background-color: #888;
		border-radius: 7px;
	}

	&::-webkit-scrollbar-track:vertical {
		background-color: #f1f1f1;
		border-radius: 5px;
	}

	/* For Firefox */
	scrollbar-width: thin;
	scrollbar-color: #888 #f1f1f1;

	/* Additional styling for the track in Firefox */
	& {
		scrollbar-track-color: #f1f1f1;
	}
`;
export const NavGridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr); /* Three columns */
	gap: 20px;
	margin: 20px;
`;
export const ToggleButton = styled.button`
	border: none;
	padding: 0;
	height: 20px;
	cursor: pointer;
	&:hover {
		svg {
			fill: #5cb335;
		}
	}
`;

export const Ribbon = styled.div`
	background-color: ${colors.white};
	display: flex;
	flex-direction: row;
	margin: 5px;
	align-items: center;
	border-bottom: 1px solid ${colors.grey3};
	height: 40px;
	box-sizing: border-box;
	justify-content: space-between;
	position: sticky;
	top: 0;
	z-index: 1;
`;

export const ToggleWrapper = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.3px;
	display: flex;
	justify-content: flex-end;
	line-height: 40px;
`;

export const TooltipContent = styled.div`
	font-size: 11px;
	text-align: left;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
	margin-top: 4px;
`;

export const SideBarNav = styled.div`
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid ${colors.grey3};
	height: 100%;
	width: 6vw;
	position: sticky;
	top: 0;
	z-index: 1;
`;

export const SidebarItem = styled.button`
border-width:0;
&:hover {
		background-color:rgb(0,255,0,0.1);
		border-right-color: #5CB335;
		border-right-width: ${({ active }) => (active === true ? '2px' : '1px')};

}
transition: all 0.2s ease-in;
>span{
	font-size:10px;
	margin-top:5px;
	font-color:${colors.grey300};
}
border-right-width: 2px;
border-right-style: solid;
border-right-color: ${({ active }) =>
	active === true ? '#5CB335' : 'transparent'};
width:100%
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
padding:5px;
cursor:pointer
`;

export const BackButtonWrapper = styled.div`
	margin: 10px;
`;
export const BackButtonContainer = styled.div`
	margin-bottom: 3px;
`;
